import { render } from "./intention-setter-v1.vue?vue&type=template&id=e5b8c35e"
import script from "./intention-setter-v1.vue?vue&type=script&lang=js"
export * from "./intention-setter-v1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__